@import '../../styles/palette';
@import '../../styles/fonts';

.checkableInputWrapper {
  display: flex;
  align-items: center;
  width: fit-content;

  input {
    opacity: 0;
    z-index: -1;
    position: absolute;
  }

  input + label {
    @include barlow(16);

    &:not(.emptyLabel) {
      margin: 0 0.5rem 0 0.5rem;
      width: auto;
      text-align: center;
    }

    &.disabled {
      color: _palette(text-secondary);
    }

    &:not(.disabled) {
      cursor: pointer;
      color: _palette(text);
    }
  }

  .icon {
    &:not(.disabled) {
      cursor: pointer;
    }

    &.disabled {
      * {
        color: _palette(text-disabled);
      }
    }

    &.checked:not(.isFocused):not(.disabled) {
      * {
        color: _palette(secondary);
      }
    }

    &.unchecked:not(.isFocused):not(.disabled) {
      * {
        color: _palette(text-secondary);
      }
    }

    &.isFocused:not(.disabled) {
      outline: auto;
      outline-offset: 0.15rem;

      * {
        color: _palette(secondary-dark);
      }
    }
  }

  &:hover:not(.disabled) {
    .icon * {
      color: _palette(secondary-dark);
    }
  }
}

.radioGroupWrapper {
  display: flex;
  gap: 1em;

  .label {
    @include barlowMedium(16);
  }

  .radioGroup {
    display: flex;
    flex-wrap: wrap;
  }
}
